import { useEffect, useState, useRef } from "react";
import { api } from "../lib/api";
import { useNavigate } from "react-router-dom";
import { Bell, Warning, EnvelopeOpen } from "@phosphor-icons/react";
import { relTime } from "../lib/labels";

export default function NotificationBell() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const ref = useRef();
  const nav = useNavigate();

  const load = async () => {
    try {
      const r = await api.get("/notifications");
      setItems(r.data);
    } catch { /* not authed */ }
  };
  useEffect(() => { load(); const id = setInterval(load, 30000); return () => clearInterval(id); }, []);
  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const unread = items.filter((i) => !i.read).length;

  const openAll = async () => {
    setOpen((v) => !v);
    if (!open && unread > 0) {
      await api.post("/notifications/mark-read").catch(() => {});
      setTimeout(load, 500);
    }
  };

  return (
    <div ref={ref} className="relative">
      <button
        onClick={openAll}
        data-testid="notif-bell"
        className="relative w-9 h-9 rounded-full flex items-center justify-center hover:bg-white/10 text-white/80"
      >
        <Bell size={18} weight={unread ? "fill" : "regular"}/>
        {unread > 0 && (
          <span className="absolute -top-0.5 -right-0.5 bg-red-500 text-white text-[0.6rem] font-bold rounded-full w-4 h-4 flex items-center justify-center">
            {unread > 9 ? "9+" : unread}
          </span>
        )}
      </button>
      {open && (
        <div className="absolute bottom-full left-0 mb-2 w-80 rounded-lg border bg-popover text-popover-foreground shadow-lg z-[9999]" data-testid="notif-panel">
          <div className="px-3 py-2 border-b flex items-center justify-between">
            <div className="font-medium text-sm">Notifications</div>
            <div className="text-xs text-muted-foreground">{items.length}</div>
          </div>
          <div className="max-h-96 overflow-y-auto">
            {items.length === 0 && <div className="px-4 py-8 text-center text-sm text-muted-foreground">Aucune alerte pour l'instant.</div>}
            {items.map((n, i) => {
              const Icon = n.kind === "contract_alert" ? EnvelopeOpen : Warning;
              const iconColor = n.kind === "contract_alert" ? "text-blue-500 mt-1"
                : n.kind === "translation_budget_alert" ? "text-red-500 mt-1"
                : "text-orange-500 mt-1";
              const target = n.kind === "translation_budget_alert" ? "/modules/translation" : null;
              return (
                <button
                  key={i}
                  data-testid={`notif-${i}`}
                  onClick={() => {
                    if (n.ticket_id) nav(`/tickets/${n.ticket_id}`);
                    else if (target) nav(target);
                    setOpen(false);
                  }}
                  className={`w-full text-left px-3 py-2 border-b last:border-b-0 hover:bg-muted flex items-start gap-2 ${n.read ? "" : "bg-blue-50/40 dark:bg-blue-950/20"}`}
                >
                  <Icon size={14} weight="fill" className={iconColor}/>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium truncate">
                      {n.kind === "escalation" && `Ticket #${n.ticket_number} — ${n.rule_name}`}
                      {n.kind === "contract_alert" && `Contrat « ${n.contract_name} » à ${n.used_percent}%`}
                      {n.kind === "translation_budget_alert" && `Module Langues — budget mensuel dépassé (${Number(n.cost_eur).toFixed(2).replace(".", ",")} € / ${Number(n.budget_eur).toFixed(2).replace(".", ",")} €)`}
                    </div>
                    <div className="text-xs text-muted-foreground truncate">{n.context || n.client_name || (n.kind === "translation_budget_alert" ? `Mois ${n.month}` : "")} · {relTime(n.at)}</div>
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
